import React from "react";
import { Link } from "react-router-dom";
import { XpaceLogo } from "./XpaceLogo";

/**
 * Compact navbar logo — uses the SVG XpaceLogo (compact variant).
 * Renders directly on the dark navbar with white wordmark and gradient X.
 */
export const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`link-reset inline-block ${className}`} data-testid="brand-logo">
      <XpaceLogo variant="compact" theme="dark" />
    </Link>
  );
};

export default Logo;
